require('intersection-observer')
import 'custom-event-polyfill'
import mbDetect from '@/pure/mbDetect'

import './filters/undigit'
import {
    i18n
} from '@/locale'
import Vue from 'vue'
import Meta from 'vue-meta'
import VeeValidate from 'vee-validate';
import router from '@/router'
import App from './App.vue'

import {
    app
} from '@/store/index.js'

Vue.config.productionTip = false
Vue.use(Meta)
Vue.use(VeeValidate, {
    classes: true,
    validity: true
});


var supportsPassive = false;
try {
    var opts = Object.defineProperty({}, 'passive', {
        get: function() {
            supportsPassive = true;
            return supportsPassive
        }
    });
    window.addEventListener("testPassive", null, opts);
    window.removeEventListener("testPassive", null, opts);
} catch (e) {
    throw e;
}
window.captureEvent = supportsPassive ? {
    passive: true
} : false
const mb = mbDetect()
Vue.prototype.mobile = mb
Vue.prototype.interaction = mb ? {
    pan: 'touchmove',
    panStart: 'touchstart',
    panEnd: 'touchend',
    active: 'touchstart',
    unactive: 'touchend'
} : {
    pan: 'mousemove',
    panStart: 'mousedown',
    panEnd: 'mouseup',
    active: 'mouseenter',
    unactive: 'mouseleave'
}

new Vue({
    router,
    data() {
        return {
            app
        }
    },
    render: h => h(App),
    i18n
}).$mount('#app')